import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import { Title } from "../component";

const Edit = (props) => (
  <RaEdit
    {...props}
    mutationMode="undoable"
    title={<Title source="fullname" />}
  >
    <Form />
  </RaEdit>
);
export default Edit;
